module.exports = __webpack_public_path__ + "static/media/btn-icon-3.57f3945d.png";